<template>
  <div class="start"></div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { URI_START } from '@/store/modules/dashboard/type'
export default {
  computed: {
    ...mapState({
      status: state => state.dashboard.state,
      totrust: state => state.dashboard.totrust
    })
  },
  async created () {
    await this.start()
    if (this.status === 1) {
      this.$router.push(`/installAuth/${this.totrust}`)
    } else {
      this.$router.push('/dashboard/0')
    }
  },
  methods: {
    ...mapActions({
      start: URI_START
    })
  }
}
</script>
